<template>
  <v-layout justify-center class="pa-0">
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="pa-0 ma-0">
        <v-toolbar dark color="#042333">
          <v-btn icon dark @click="fechar()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Nova Sugestão de Compra</v-toolbar-title>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-text class="mt-3 mr-0 pa-0">
          <v-data-table
            id="v-data-table-novas-sugestao-compra"
            v-model="produtosSelecionados"
            :headers="headers"
            :items="desserts"
            item-key="idproduto"
            fixed-header
            class="titulo-tabela-top font-resp-tabela table-full-screen"
            show-select
            :search="search"
          >
            <template v-slot:top>
              <div style="display: flex" class="px-3 my-4">
                <h3 class="title">
                  <v-icon>mdi-format-list-bulleted-square</v-icon>
                  Lista de Produtos
                </h3>

                <v-divider class="mx-4" inset vertical></v-divider>

                <template v-if="produtosSelecionados.length">
                  <v-btn
                    color="#042333"
                    small dark
                    class="mt-1 ml-1"
                    @click="verifificaCompraOportunidade()"
                  >
                    <v-icon left small>mdi-cart</v-icon>
                    <span>Atualizar</span>
                    <span class="qtde-top-button-small">{{ produtosSelecionados.length }}</span>
                  </v-btn>

                  <v-btn
                    color="error"
                    small dark
                    class="mt-1 ml-5"
                    @click="descartarSelecionados()"
                  >
                    <v-icon left small>mdi-delete</v-icon>
                    <span>Descartar</span>
                    <span class="qtde-top-button-small">{{ produtosSelecionados.length }}</span>
                  </v-btn>

                  <v-switch
                    v-model="igualarTodasSugestaoEQtde"
                    label="Igualar a Qtde. com a nova Sugestão"
                    class="mt-1 ml-5" hide-details aria-label="ml-5"
                    @click="igualarSelecionado()"
                  ></v-switch>
                </template>

                <v-spacer></v-spacer>

                <div :class="!produtosSelecionados.length ? 'w-500' : 'w-400'">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar produto"
                    single-line
                    hide-details
                    clearable
                    class="ma-0 pa-0"
                  ></v-text-field>
                </div>
              </div>

              <compraOportunidade
                :dialog="dialogCompraOportunidade"
                :mult="true"
                @cancelar="dialogCompraOportunidade = false"
                @salvar="atualizarMultiplos($event)"
              ></compraOportunidade>
            </template>
            <template v-slot:item.sugerido="{ item }">
              {{ Helpers.formatarValor(item.sugerido) }}
            </template>
            <template v-slot:item.nova_sugestao="{ item }">
              {{ Helpers.formatarValor(item.nova_sugestao) }}
            </template>
            <template v-slot:item.qtde_pedido="{ item }">
              <sysInputFormatador
                v-model="item.qtde_pedido"
                :max-digitos="Config.QTDE_DECIMAIS"
                :removerValorIrrelevante="true"
                centralizar
                class="input-regular w-100"
                @focus="$event.target.select()"
              ></sysInputFormatador>
            </template>
            <template v-slot:item.preco_custo_base="{ item }">
              {{ Helpers.formatarValor(item.preco_custo_base) }}
            </template>
            <template v-slot:item.preco_custo="{ item }">
              <sysInputFormatador
                v-model="item.preco_custo"
                :max-digitos="Config.QTDE_DECIMAIS"
                :removerValorIrrelevante="true"
                centralizar
                class="input-regular w-100"
                @focus="$event.target.select()"
              ></sysInputFormatador>
            </template>

            <template v-slot:item.igualar_qtde_sugestao="{ item }">
              <v-tooltip bottom open-delay="800">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-switch
                      v-model="item.igualar_qtde_sugestao"
                      hide-details
                      @click="igualarSelecionado(item)"
                    ></v-switch>
                  </div>
                </template>
                <span>A Quantidade será igualada a nova Sugestão de compra.</span>
              </v-tooltip>
            </template>

            <template v-slot:item.opts="{ item }">
              <v-row dense>
                <template v-if="item.qtde_pedido > 0 && item.preco_custo > 0">
                  <v-btn icon
                    @click="editItemCarrinho(item)"
                    title="Atualizar Produto no Carrinho de Compra"
                  >
                    <v-icon>mdi-cart</v-icon>
                  </v-btn>
                </template>

                <template v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon color="error" v-bind="attrs" v-on="on">
                        <v-icon>mdi-alert-circle</v-icon>
                      </v-btn>
                    </template>
                    <span v-if="!item.qtde_pedido > 0">Quantidade deve ser maior que zero.</span>
                    <span v-else>Preço de Custo deve ser maior que zero.</span>
                  </v-tooltip>
                </template>

                <v-btn icon @click="removerItem(item)" title="Descartar nova Sugestão de Compra">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-row>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import CarrinhoAPI from '../../../../api/carrinho'
import sysInputFormatador from '../../../utils/InputFormatadorDeValor'
import compraOportunidade from "../../CompraOportunidade";
import {mapGetters} from "vuex";

export default {
  name: "ConfirmarAlteracaoSugestao",
  components: { sysInputFormatador, compraOportunidade },
  model: {
    prop: 'dialog',
    event: 'change'
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    produtos: {
      type: Array
    },
    sugestaoAtualizada : {
      type: Object
    },
    pedidoSelecionado: {
      type: Object
    },
    ativarCompraOportunidade: {
      type: String,
      default: 'N'
    }
  },
  data () {
    return {
      headers: [
        { text: 'Id Produto', value: 'idproduto' },
        { text: 'Descrição Produto', value: 'descricao_produto' },
        { text: 'Antiga Sugestão', value: 'sugerido' },
        { text: 'Nova Sugestão', value: 'nova_sugestao' },
        { text: 'Qtde. no Carrinho', value: 'qtde_pedido' },
        { text: 'Igualar', value: 'igualar_qtde_sugestao', align: 'center'  },
        { text: 'Último Preço (R$)', value: 'preco_custo_base' },
        { text: 'Preço Atual (R$)', value: 'preco_custo' },
        { text: 'Opções', value: 'opts', width: '80px' },
      ],
      desserts: [],
      produtosSelecionados: [],
      search: '',
      igualarTodasSugestaoEQtde: false,
      dialogCompraOportunidade: false
    }
  },
  computed: {
    ...mapGetters({
      fornecedor: "fornecedor/getFornecedor",
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
    })
  },
  watch: {
    produtos () {
      this.desserts = this.produtos
    },
    desserts () {
      if (!this.desserts.length) {
        this.$emit('change')
      }
    },
    sugestaoAtualizada () {
      if (this.sugestaoAtualizada) {
        if (this.sugestaoAtualizada.erro) {
          alert('Erro ao tentar atualizar produto no carrinho.')
        } else {
          this.removerItem(this.sugestaoAtualizada)
        }
      }
    }
  },
  methods: {
    igualarSelecionado (produto = {}) {
      const ITENS = produto.idproduto ? [produto] : this.produtosSelecionados

      ITENS.forEach(item => {
        if (!produto.idproduto) {
          item.igualar_qtde_sugestao = this.igualarTodasSugestaoEQtde
        }

        if (item.igualar_qtde_sugestao) {
          item.qtde_pedido = item.nova_sugestao
        } else {
          item.qtde_pedido = item.qtde_no_carrinho
        }
      })
    },
    fechar () {
      this.$emit('change')
    },
    editItemCarrinho (item) {
      const { qtde_pedido, preco_custo } = item

      if (qtde_pedido > 0 && preco_custo > 0) {
        this.$emit('edit-item-carrinho', item)
      }
    },
    removerItem (item) {
      this.desserts = this.desserts.filter(dessert => dessert !== item)
    },
    descartarSelecionados () {
      this.produtosSelecionados.forEach(item => {
        this.removerItem(item)
      })

      this.produtosSelecionados = []
    },
    verifificaCompraOportunidade () {
      let compraOportunidade = false

      if (this.ativarCompraOportunidade === 'S') {
        const length = this.produtosSelecionados.length

        for (let i = 0; i < length; i++) {
          const item = this.produtosSelecionados[i]

          if (item.qtde_pedido > parseFloat(item.nova_sugestao) && item.preco_custo > 0) {
            compraOportunidade = !compraOportunidade
            i = length;
            // break
          }
        }
      }

      if (compraOportunidade) {
        this.dialogCompraOportunidade = true
      } else {
        this.atualizarMultiplos()
      }
    },
    atualizarMultiplos (motivos = []) {
      const headers = this.Helpers.iniciarRequisicao()

      let produtos = []

      this.produtosSelecionados.forEach(item => {
        const {
          idproduto,
          preco_custo,
          sugerido,
          qtde_pedido,
          nova_sugestao,
          igualar_qtde_sugestao: igualar
        } = item

        const produto = {
          idproduto,
          preco_custo,
          sugerido,
          qtde: igualar ? nova_sugestao : qtde_pedido,
          motivos,
          nova_sugestao
        }

        if (produto.qtde > 0 && produto.preco_custo > 0)
          produtos.push(produto)
        else {
          this.produtosSelecionados = this.produtosSelecionados.filter(prop => prop !== item)
        }
      })

      if (produtos.length > 0) {
        const params = {
          fornecedor: this.fornecedor.id,
          grupo: this.pedidoSelecionado.grupo,
          filial: this.grupoCompra > 0 ? this.filialCompra : 0,
          produtos
        }

        this.$store.dispatch(
          "loading/addRequisicao",
          CarrinhoAPI.atualizarMultiplosProdutos(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.descartarSelecionados()
              this.igualarTodasSugestaoEQtde = false
              this.dialogCompraOportunidade = false
              this.$emit('atualizar-pedido-carrinho')
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    }
  }
}
</script>

<style>
#v-data-table-novas-sugestao-compra .v-data-table__wrapper {
  height: calc(100vh - 185px) !important;
  overflow-y: auto !important;
}
.w-400 {
  width: 400px;
}
</style>
